export function isUploadedFromStudio(url: string)  {
	const imgPrefix = 'https://'
	const bucketPartial = 'a8-marketplace'
	return url.startsWith(imgPrefix)
}

export function isValidHttpUrl(urlInput: string) {
  let url;
  try {
    url = new URL(urlInput);
  } catch (_) {
    return false;  
  }
  return url.protocol === "http:" || url.protocol === "https:";
}
